(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-color-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    function markSelected(container, btn) {
      container.querySelectorAll('.custom-shade-swatches__dot').forEach(function (d) {
        d.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
    }

    function initDefaults() {
      document.querySelectorAll('.custom-shade-swatches').forEach(function (container) {
        if (container.dataset.swatchesInit) return;
        container.dataset.swatchesInit = 'true';
        var defaultId = container.dataset.defaultVariantId;
        var dots = container.querySelectorAll('.custom-shade-swatches__dot');
        var matched = null;
        dots.forEach(function (d) {
          if (d.dataset.variantId === defaultId) matched = d;
        });
        if (!matched && dots.length) matched = dots[0];
        if (matched) matched.classList.add('is-selected');
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.custom-shade-swatches__dot');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var container = btn.closest('.custom-shade-swatches');
      if (container) markSelected(container, btn);

      var card = btn.closest('product-card') || btn.closest('.product-card');
      if (!card) return;
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      var variantInput = card.querySelector('quick-add-component input[name="id"]');
      if (variantInput) variantInput.value = variantId;
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDefaults);
    } else {
      initDefaults();
    }

    document.addEventListener('shopify:section:load', initDefaults);
  })();
  } catch(e) { console.error(e); }
})();

})();
